module.exports = __webpack_public_path__ + "assets/img/elem2-transperent-bcg.7cb7a3eb.png";